import Vue from "vue";
import Component from "vue-class-component";

import dayjs from "dayjs";
import "dayjs/locale/ru"; // import locale

@Component
export class DateMix extends Vue {
    getCalendarDate(): any {
        //let result = dayjs().format("DD.MM.YYYY ");
        let result = new Date().toDateString();

        const dta = new Date();
        let dDate = {
            year: dta.getFullYear(),
            month: dta.getMonth(),
            day: dta.getDate(),
        };

        if (this.$router.currentRoute["meta"] && this.$router.currentRoute["meta"]["props"]["mode"] === "value") {
            const date = new Date(Number(this.$router.currentRoute.params["Date"]));
            //result = dayjs(date.toDateString()).format("DD.MM.YYYY");
            dDate = {
                year: date.getFullYear(),
                month: date.getMonth(),
                day: date.getDate(),
            };

            result = date.toDateString();
        }
        return { current: result, formatted: dDate };
    }

}
